<template>
    <LiveSalesBoard
        :sales="sales"
        :house-name="operations.houseName"
        :loading="loading"
        :failure="failureText"
        @refresh="refresh"
        @open-clerk="openClerk"
    />
</template>

<script setup>
import { computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'

import LiveSalesBoard from '@/components/LiveSalesBoard.vue'
import { useLiveSales } from '@/composables/useLiveSales.js'
import { useOperationsContextStore } from '@/stores/operations-context.store.js'

// The host half of the Live Sales page: which house (the operations context
// store, shared with the shell's switcher), the data (the composable), and
// where "Open Clerk" goes: the clerk route, keyed on the runtime's event id,
// in a NEW TAB (ruled 2026-09-22) — a clerk keeps the console up beside this
// page rather than inside it.
const router = useRouter()
const operations = useOperationsContextStore()
const houseCode = computed(() => operations.houseCode)
const { sales, loading, failure, refresh } = useLiveSales({ houseCode })

const failureText = computed(function () {
    if (failure.value === null) {
        return ''
    }
    return `The sales could not be read: ${failure.value.message ?? failure.value}`
})

onMounted(function () {
    operations.ensureHouses()
    refresh()
})

function openClerk(eventId) {
    const { href } = router.resolve({ name: 'clerk', params: { eventId } })
    window.open(href, '_blank', 'noopener')
}
</script>
